import React from "react";
import { Box, Typography, Stack, Card, CardContent, Grid } from "@mui/material";

// Icons
import InfoIcon from '@mui/icons-material/Info';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import BlockIcon from '@mui/icons-material/Block';


export const StatusLegend = () => (
    <Card elevation={0} sx={{ border: '1px solid #e2e8f0', borderRadius: 4, mb: 3, bgcolor: '#fff' }}>
        <CardContent sx={{ p: '16px !important' }}>
            <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 1.5, color: 'text.secondary', display: 'flex', alignItems: 'center', gap: 1 }}>
                <InfoIcon fontSize="small" color="disabled" /> UNDERSTANDING STATUSES
            </Typography>
            <Grid container spacing={3}>
                <Grid size={{ xs: 12, md: 4 }}>
                    <Stack direction="row" spacing={1} alignItems="flex-start">
                        <CheckCircleOutlineIcon sx={{ color: '#10b981', fontSize: 20, mt: 0.2 }} />
                        <Box>
                            <Typography variant="body2" sx={{ fontWeight: 700, color: '#10b981' }}>Ready to process</Typography>
                            <Typography variant="caption" color="text.secondary" sx={{ display: 'block', lineHeight: 1.3, mt: 0.5 }}>
                                Transfers/Payouts to the producer have been successfully completed. Funds are ready to be moved.
                            </Typography>
                        </Box>
                    </Stack>
                </Grid>
                <Grid size={{ xs: 12, md: 4 }}>
                    <Stack direction="row" spacing={1} alignItems="flex-start">
                        <HourglassEmptyIcon sx={{ color: '#f59e0b', fontSize: 20, mt: 0.2 }} />
                        <Box>
                            <Typography variant="body2" sx={{ fontWeight: 700, color: '#f59e0b' }}>Awaiting dependencies</Typography>
                            <Typography variant="caption" color="text.secondary" sx={{ display: 'block', lineHeight: 1.3, mt: 0.5 }}>
                                Waiting for producer transfer or payout. Amounts may stagnate here due to missing RIB, lack of funds, or technical errors.
                            </Typography>
                        </Box>
                    </Stack>
                </Grid>
                <Grid size={{ xs: 12, md: 4 }}>
                    <Stack direction="row" spacing={1} alignItems="flex-start">
                        <BlockIcon sx={{ color: '#ef4444', fontSize: 20, mt: 0.2 }} />
                        <Box>
                            <Typography variant="body2" sx={{ fontWeight: 700, color: '#ef4444' }}>Blocked</Typography>
                            <Typography variant="caption" color="text.secondary" sx={{ display: 'block', lineHeight: 1.3, mt: 0.5 }}>
                                Blocked because the Producer is not validated (KYC issue). Funds will only be unlocked when the producer becomes VALIDATED.
                            </Typography>
                        </Box>
                    </Stack>
                </Grid>
            </Grid>
        </CardContent>
    </Card>
);





